import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const JSFile = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box>
            <Typography variant="h5" gutterBottom><strong>JavaScript File Support</strong></Typography>

            <Typography variant="body1" gutterBottom>
                HawkClient allows you to create standalone JavaScript files that can be imported and used within your request or collection-level scripts.
                This feature enables you to organize and reuse logic across multiple scripts, making your testing setup more modular and maintainable.
            </Typography>

            <Typography variant="body1" gutterBottom>
                In the screenshot below, we have a file named <strong>"test script.js"</strong>, which contains two test cases exported under the name <code>testscript</code>.
            </Typography>

            <img
                src="/scripts/jsfile.png"
                alt="JavaScript file in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '70%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />

            <br />
            <br />

            <Typography variant="body1" gutterBottom>
                This exported function <code>testscript</code> is then imported into the post-response script.
                As shown in the example below, calling <code>testscript()</code> will execute the defined test cases from the JavaScript file.
            </Typography>

            <img
                src="/scripts/jsfiletest.png"
                alt="Executing JS file logic in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '70%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />
        </Box>
    )
};

export default JSFile;
